<template>
    <div class="modal fade" id="modal-fingerPrint" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel"></h5>
                    <button type="button" class="close" aria-label="Close" v-on:click="goBack()">
                         <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">                            
                    <template v-if="strPrice == 'noAvailability'">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center mb-3">
                                <svg width="45" height="45" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.656 8.864q0-2.208 1.568-3.776t3.776-1.568 3.776 1.568 1.6 3.776q0 0.256-0.064 0.448l-1.76 6.944q-0.096 1.408-1.12 2.368t-2.432 0.96q-1.376 0-2.4-0.928t-1.152-2.304q-0.32-0.96-0.672-2.112t-0.736-2.784-0.384-2.592zM12.416 24.928q0-1.472 1.056-2.496t2.528-1.056 2.528 1.056 1.056 2.496q0 1.504-1.056 2.528t-2.528 1.056-2.528-1.056-1.056-2.528z"
                                          fill="#bd030a"></path>
                                </svg>
                            </div>
                            <div class="col-12 d-flex justify-content-center mb-3 text-center">
                                <span style="color: #bd030a;font-size:21px;">{{ __('messages.error_reserv') }}</span>
                            </div>

                            <div class="col-6 d-flex justify-content-center mb-3">

                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
   import { HotelAnalytic } from '../../analytics/HotelsAnalytics'
    import { storeToRefs } from 'pinia';
    import { useFingerStore } from '../../stores/fingerprint';

    const settings = __pt.settings.site || {};

    export default {
        props: {
            quote: {},
            bookingId:0,
            submitBooking: {
                type: Function,
                required: true
            },
            redirectUrl: '',
           
        },
        data() {
            return {
                diffPrice: 0,
                strPrice: ""
            };
        },
        setup() {
            const storeFingerStore = useFingerStore();
            const { getFingerprintHash } = storeToRefs(storeFingerStore);

            return {
                getFingerprintHash
            };
        },
        async mounted() {
            this.setDiff();
        },
        methods: {
            setDiff() {
                let transferAmount = 0;
                    this.strPrice = "noAvailability";
                    HotelAnalytic.setErrorToken({
                        action: "fingerprint",
                        oldRate: 0,
                        newRate: 0
                    }, this.quote, this.getFingerprintHash, this.bookingId);

                    return;
                
               
				
            },
            goBack() {
                window.location.href = this.redirectUrl;                
            }

        }
    }
</script>
